import { useEffect, useRef, useState } from 'react'

import { Autoplay, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/navigation'

import '../styles/certificados.css'
import { ChevronLeft, ChevronRight } from 'lucide-react'

export default function Certificados({ text }) {
  const [activeSlide, setActiveSlide] = useState(0)
  const [totalSlides, setTotalSlides] = useState(4)
  const swiperRef = useRef(null)
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640

  const certificados = [
    '../assets/certificados/KANBANCOACHIN.png',
    '../assets/certificados/KANBANSYSTEM.png',
    '../assets/certificados/Businessmap_Logo.png',
    '../assets/certificados/CUSTOMEREXP.png',
    '../assets/certificados/ACREDK.png',
    '../assets/certificados/KANBANMANAGNMENT.png',
    '../assets/certificados/SCRUM.png',
    '../assets/certificados/Mask_group.png',
    '../assets/certificados/SPC.png',
    '../assets/certificados/SASAFE.png',
    '../assets/certificados/KANBANUNIVERSITY.png',
    '../assets/certificados/CSM.png',
    '../assets/certificados/AWS_Partner.png',
    '../assets/certificados/AWS_Certified_Cloud_Practitioner.png',
    '../assets/certificados/AWS_Certified_Solutions_Architect.png',
    '../assets/certificados/KANBANSYSTENSIMPRO.png',
  ]

  // Get the number of slides to show based on screen width
  const getSlidesPerView = () => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 640) return 1
      if (window.innerWidth < 1024) return 2
      return 4
    }
    return 4 // Default for SSR
  }

  const [slidesPerView, setSlidesPerView] = useState(getSlidesPerView())

  // Update slides per view on window resize
  useEffect(() => {
    const handleResize = () => {
      setSlidesPerView(getSlidesPerView())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Set total slides to the total number of items
  useEffect(() => {
    setTotalSlides(certificados.length)
  }, [certificados.length])

  // Handle slide change
  const handleSlideChange = swiper => {
    setActiveSlide(swiper.realIndex)
  }

  // Go to specific slide
  const goToSlide = index => {
    if (swiperRef.current?.swiper) {
      swiperRef.current.swiper.slideTo(index)
    }
  }

  return (
    <div className="relative bg-[#000] py-[30px] px-[20px] md:p-[80px] overflow-hidden">
      <div className="relative z-10 max-w-[1100px] m-auto">
        <h2 className="text-5xl text-white font-normal text-center">{text}</h2>
        <div className="mt-12 md:mt-24 relative certificados-carousel">
          <Swiper
            ref={swiperRef}
            modules={[Navigation, Autoplay]}
            spaceBetween={30}
            slidesPerView={slidesPerView}
            slidesPerGroup={1}
            navigation={!isMobile}
            loop={false}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            onSlideChange={swiper => handleSlideChange(swiper)}
            onInit={swiper => {
              setActiveSlide(swiper.realIndex)
            }}
            className="mySwiper px-8"
            style={{
              '--swiper-navigation-color': '#fff',
              '--swiper-navigation-size': '18px',
              '--swiper-navigation-sides-offset': '0px',
            }}
          >
            {certificados.map((src, index) => (
              <SwiperSlide key={index}>
                <div className="flex items-center justify-center h-[90px] px-8">
                  <img
                    src={src}
                    alt={`Certificado ${index + 1}`}
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="flex justify-center mt-8 gap-4">
            <button
              type="button"
              onClick={() => {
                const prevIndex = (activeSlide - 1 + totalSlides) % totalSlides
                goToSlide(prevIndex)
              }}
              className="md:hidden"
            >
              <ChevronLeft className="text-white" />
            </button>
            <div className="flex flex-row gap-3 items-center">
              {Array.from({ length: 3 }).map((_, i) => {
                const isActive =
                  Math.floor(activeSlide / Math.ceil(totalSlides / 3)) === i

                const isThirdDot = i === 2

                return (
                  <div
                    key={i}
                    onClick={() => {
                      goToSlide(i * Math.ceil(totalSlides / 3))
                    }}
                    className={`h-1.5 rounded-full cursor-pointer transition-all duration-300 ${
                      isActive
                        ? isThirdDot
                          ? 'w-[6px] bg-transparent border border-white'
                          : 'w-[20px] bg-transparent border border-white'
                        : isThirdDot
                          ? 'w-[6px] bg-white'
                          : 'w-[20px] bg-white'
                    }`}
                    aria-label={`Go to group ${i + 1}`}
                  />
                )
              })}
            </div>
            <button
              type="button"
              onClick={() => {
                const nextIndex = (activeSlide + 1) % totalSlides
                goToSlide(nextIndex)
              }}
              className="md:hidden"
            >
              <ChevronRight className="text-white" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}